import React from "react";

export default function CloseConfirmPopup({
  onClose,
  onCancel,
} : {
  onClose: () => void,
  onCancel: () => void,
}) {
  return (
    <div>
        <div className="overlay_second overlay pop_on" onClick={() => onCancel()}></div>
        <div className="popup_second popup size pop_on">
            <h1 className="">
                <div>本当に閉じますか？</div>
            </h1>
            <div className="popup_inner">
                <div className="popup_inner_content">
                    <form className="cake_ajax_form">
                        <div className="form__body">
                            <ul>
                                <li className="bt">
                                    <button className="submit_bt_1" type="button" onClick={() => onCancel()}>キャンセル</button>
                                    <button className="submit_bt_2" type="button" onClick={() => onClose()}>OK</button>
                                </li>
                            </ul>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  );
}

